/**
 * Web Audio API chime player — plays a short generated tone matching the
 * user's chosen style. No audio files required, low memory, cross-browser.
 * "vibrate" style uses `navigator.vibrate` and produces no sound.
 */
export function playChime(style = "ping") {
  try {
    if (style === "vibrate") {
      if (navigator.vibrate) navigator.vibrate([120, 60, 120]);
      return;
    }
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    const ctx = new AC();
    const now = ctx.currentTime;
    if (style === "bell") {
      // Two-tone soft bell (fundamental + harmonic)
      [880, 1320].forEach((freq, i) => {
        const o = ctx.createOscillator();
        const g = ctx.createGain();
        o.type = "sine";
        o.frequency.setValueAtTime(freq, now);
        const peak = i === 0 ? 0.32 : 0.14;
        g.gain.setValueAtTime(0.0001, now);
        g.gain.exponentialRampToValueAtTime(peak, now + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, now + 1.4);
        o.connect(g); g.connect(ctx.destination);
        o.start(now); o.stop(now + 1.5);
      });
    } else {
      // "ping" — short bright triangle chime
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "triangle";
      o.frequency.setValueAtTime(1200, now);
      o.frequency.exponentialRampToValueAtTime(1600, now + 0.08);
      g.gain.setValueAtTime(0.0001, now);
      g.gain.exponentialRampToValueAtTime(0.28, now + 0.01);
      g.gain.exponentialRampToValueAtTime(0.0001, now + 0.3);
      o.connect(g); g.connect(ctx.destination);
      o.start(now); o.stop(now + 0.35);
    }
  } catch { /* silent — audio may be blocked before user gesture */ }
}
